<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Group Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="group.title" maxlength="250"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Start Date & Time" label-position="inside">
                        <b-datetimepicker
                            v-model="group.start_at"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body
                            :min-datetime="conf.start_at"
                            :max-datetime="conf.end_at"
                            :editable="true"
                            :timepicker="timepicker"
                        >
                        </b-datetimepicker>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="End Date & Time" label-position="inside">
                        <b-datetimepicker
                            v-model="group.end_at"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body
                            :min-datetime="conf.start_at"
                            :max-datetime="conf.end_at"
                            :editable="true"
                            :timepicker="timepicker"
                        >
                        </b-datetimepicker>
                    </b-field>
                </div>
                <div class="column is-3">
                    <b-field label="Log Time (Minutes)" label-position="inside">
                        <b-input type="number" v-model="group.log_minutes" min="0"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import async from "async";
    import {client as http} from "../../../../http_client";

    export default {
        name: 'GroupForm',
        props: {
            group: {
                type: Object,
                required: true
            },
            conf: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {},
                timepicker: {
                    incrementMinutes: 5
                },
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
